import React from 'react';
import Heading from '../../shared/Heading';

export const FEATURED_PODCASTS = [
  {
    imageUrls: [
      'images/homepage/featured-podcasts/brave.png',
      'images/homepage/featured-podcasts/brave@2x.png',
      'images/homepage/featured-podcasts/brave@3x.png',
    ],
    url: 'https://anchor.fm/bravenotperfect',
    name: 'Brave Not Perfect with Reshma Saujani',
  },
  {
    imageUrls: [
      'images/homepage/featured-podcasts/bts.png',
      'images/homepage/featured-podcasts/bts@2x.png',
      'images/homepage/featured-podcasts/bts@3x.png',
    ],
    url: 'https://anchor.fm/beachtoosandy',
    name: 'Beach Too Sandy, Water Too Wet',
  },
  {
    imageUrls: [
      'images/homepage/featured-podcasts/couplestherapy.png',
      'images/homepage/featured-podcasts/couplestherapy@2x.png',
      'images/homepage/featured-podcasts/couplestherapy@3x.png',
    ],
    url: 'https://anchor.fm/couples-therapy',
    name: 'Couples Therapy with Candice & Casey',
  },
  {
    imageUrls: [
      'images/homepage/featured-podcasts/dissect.png',
      'images/homepage/featured-podcasts/dissect@2x.png',
      'images/homepage/featured-podcasts/dissect@3x.png',
    ],
    url: 'https://anchor.fm/dissect',
    name: 'Dissect',
  },
  {
    imageUrls: [
      'images/homepage/featured-podcasts/dkmh.png',
      'images/homepage/featured-podcasts/dkmh@2x.png',
      'images/homepage/featured-podcasts/dkmh@3x.png',
    ],
    url: 'https://anchor.fm/dkmh',
    name: 'DKMH',
  },
  {
    imageUrls: [
      'images/homepage/featured-podcasts/haikunews.png',
      'images/homepage/featured-podcasts/haikunews@2x.png',
      'images/homepage/featured-podcasts/haikunews@3x.png',
    ],
    url: 'https://anchor.fm/haikunews',
    name: 'Haiku News',
  },
];

export const FEATURES_CONTENT = [
  {
    svgType: 'tools',
    title: 'Easy-to-use creation tools',
    text:
      'Record or upload, and edit from any device with tools designed to make you sound great, regardless of your skill level.',
    mobileText:
      'Record, edit, and add clips from any device with tools designed to make you sound great, regardless of your skill level.',
    linkUrl: '/features',
    imageWidth: 430,
    svgWidths: {
      small: 430,
      medium: 430,
      large: 430,
    },
    mobileSvgWidths: {
      small: 186,
      medium: 186,
      large: 230,
    },
  },
  {
    svgType: 'distribution',
    title: '100% free hosting & distribution',
    text:
      'No storage limits, no trial period, no catch. Automatically distributed to Spotify, Apple Podcasts, Google Podcasts, and all other major listening platforms.',
    linkUrl: '/features',
    imageWidth: 350,
    svgWidths: {
      small: 350,
      medium: 350,
      large: 350,
    },
  },
  {
    svgType: 'monetization',
    title: (() => (
      <>
        {'Get paid to podcast'} <br />
        <Heading size="xs">(available in the US, expanding soon)</Heading>
      </>
    ))(),
    text:
      'Record audio ads in your own voice and earn money whenever people listen to your podcast—no matter your audience size.',
    linkUrl: '/features',
    imageWidth: 286,
    svgWidths: {
      small: 286,
      medium: 236,
      large: 250,
    },
  },
  {
    svgType: 'analytics',
    title: 'Straightforward analytics',
    text:
      'Track your growth on the go and get to know your listeners with cross-platform insights.',
    linkUrl: '/features',
    imageWidth: 360,
    svgWidths: {
      small: 360,
      medium: 360,
      large: 360,
    },
  },
];

export const GOOGLE_DESIGN_URLS = [
  'images/homepage/press/googledesign.png',
  'images/homepage/press/googledesign@2x.png',
  'images/homepage/press/googledesign@3x.png',
];

export const FAST_COMPANY_URLS = [
  'images/homepage/press/fastcompany.png',
  'images/homepage/press/fastcompany@2x.png',
  'images/homepage/press/fastcompany@3x.png',
];

export const LAPTOP_IMAGE_URLS = [
  'images/homepage/hero-desktop.png',
  'images/homepage/hero-desktop@2x.png',
];
